import { Injectable } from '@angular/core';
import { CanActivate, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanLoad } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AuthNZService } from '../core/authnz.service';
import { ApplicationStates } from '../core/auth-nz/interfaces';

@Injectable({
  providedIn: 'root'
})
export class RequireLoggedInUserAuthGuard implements CanActivate, CanLoad {
  constructor(
    private authnz: AuthNZService,
    private router: Router,
  ){}
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(null, null);
  }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      const authState = await this.authnz.authState$.nThEmitAsPromise();
      if (authState != ApplicationStates.LoggedIn) {
        this.router.navigate(['login']);
        return false;
      }
      return true;
  }
}


/**
 * TODO: Support alternante non-logged in statuses
 * 
 * PendingEmailVerification
 * LoggedOut
 */
@Injectable({
  providedIn: 'root'
})
export class RequireLoggedOutUserAuthGuard implements CanActivate, CanLoad {
  constructor(
    private authnz: AuthNZService,
    private router: Router,
  ){}
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(null, null);
  }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      const authState = await this.authnz.authState$.nThEmitAsPromise();
      if (authState == ApplicationStates.LoggedIn) {
        this.router.navigate(['/']);
        return false;
      }
      return true;
  }
}



